import isBackdropClick from '../../dialog_backdrop';
import { expandAncestorDisclosures } from './disclosure';

const openDialog = dialog => {
  if (dialog.open) {
    return;
  }

  expandAncestorDisclosures(dialog);
  dialog.showModal();

  // A modal inside a `display: none` subtree paints nothing while making the rest
  // of the document inert: give up rather than freeze the page.
  if (!dialog.checkVisibility()) {
    dialog.close();
    return;
  }

  document.body.style.overflow = 'hidden';
};

if (window.dialogInitialized === undefined) {
  window.dialogInitialized = true;

  let pressEvent = null;

  document.addEventListener('mousedown', event => {
    pressEvent = event;
  });

  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-dialog-trigger]');

    if (trigger) {
      const dialog = document.getElementById(
        trigger.getAttribute('aria-controls'),
      );

      if (dialog) {
        openDialog(dialog);
      }

      return;
    }

    if (event.target.closest('[data-dialog-close]')) {
      event.target.closest('dialog')?.close();
      return;
    }

    if (
      event.target.matches('dialog[data-dialog]') &&
      isBackdropClick(event.target, event, pressEvent)
    ) {
      event.target.close();
    }
  });

  // `close` does not bubble, so it is caught on the way down.
  document.addEventListener(
    'close',
    () => {
      if (!document.querySelector('dialog[open]')) {
        document.body.style.overflow = '';
      }
    },
    true,
  );

  const openFlagged = () => {
    document.querySelectorAll('[data-dialog-open-on-load]').forEach(openDialog);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', openFlagged);
  } else {
    openFlagged();
  }
}
